import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useContext } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { AppContext } from 'context';
import PrintIcon from 'svg/print.svg';
import ShareIcon from 'svg/share.svg';
import styles from './MobilePDFActions.pcss';
const externalHandlers = {
    share: '/mobile/share',
    print: '/mobile/print'
};
const MobilePDFActions = ({ fileUrl })=>{
    useStyles(styles);
    const { externalRedirect, domain } = useContext(AppContext);
    const onActionHandler = (action)=>{
        externalRedirect(`${externalHandlers[action]}?fileUrl=${domain}${fileUrl}`);
    };
    const actions = {
        share: {
            Icon: ShareIcon,
            onClickHandler: ()=>onActionHandler('share')
        },
        print: {
            Icon: PrintIcon,
            onClickHandler: ()=>onActionHandler('print')
        }
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: Object.entries(actions).map(([key, { Icon, onClickHandler }])=>/*#__PURE__*/ _jsx("div", {
                className: styles.bottomNavIcon,
                children: /*#__PURE__*/ _jsx(Icon, {
                    onClick: onClickHandler
                })
            }, key))
    });
};
export default MobilePDFActions;
